import React, { useState, useEffect } from 'react';

import { bemCssModules, correctingTrailingNumbers } from '@cryptoboyio/mercuryo-lab/utils';

import { useLocation, useNavigate } from '@utils/hooks';

import { useStore, walletActions } from '@modules';
import { CurrencyEnum } from '@modules/global/types';
import { GETRateResponse, RateTypesEnum } from '@modules/wallet/types';

import InfoIcon from './info.svg';

import styles from './RateInformer.scss';

const cn = bemCssModules(styles, 'RateInformer');

export type TRateInformer = {
  crypto: CurrencyEnum;
  fiat: CurrencyEnum;
  type?: RateTypesEnum;
  customRate?: string;
};

const RateInformer: CustomFC<TRateInformer> = props => {
  const { crypto, fiat, type = RateTypesEnum.buy, className, customRate } = props;

  const navigate = useNavigate();
  const [{ global, wallet }, dispatch] = useStore();
  const [isShowRates, setIsShowRates] = useState(false);
  const [infoRate, setInfoRate] = useState<GETRateResponse>();

  const displayOptions = global.currencies.config.display_options;
  const from = type === RateTypesEnum.sell ? crypto : fiat;
  const to = type === RateTypesEnum.sell ? fiat : crypto;
  const rate = correctingTrailingNumbers(
    customRate || infoRate?.rate || '',
    displayOptions[fiat]?.display_digits,
    displayOptions[fiat]?.total_digits
  );
  const rateText = `1 ${crypto} = ${rate} ${fiat}`;
  const { pathname } = useLocation();

  useEffect(() => {
    setIsShowRates(false);
    dispatch(walletActions.getRateForRateInformer({ from, to, type }))
      .unwrap()
      .then(res => {
        setIsShowRates(true);
        setInfoRate(res.data);
      })
      .catch(() => setIsShowRates(false));
  }, [crypto, fiat, type]);

  const handleTransfer = () => {
    navigate<'limits'>(`${CONST.nav.limits}/${crypto}`, {
      state: {
        from: pathname,
        fiatCurrency: fiat,
      },
    });
  };

  const isLoading = wallet.loaders.getWalletLimits !== false && !infoRate;

  if (!isShowRates || isLoading) return null;

  return (
    <div className={cn(null, [className])}>
      <button className={cn('icon')} type="button" onClick={handleTransfer}>
        <InfoIcon />
      </button>
      {rate && rateText}
    </div>
  );
};

export default RateInformer;
